import { render, staticRenderFns } from "./LinksKLA.vue?vue&type=template&id=12176c9a&scoped=true"
import script from "./LinksKLA.vue?vue&type=script&lang=js"
export * from "./LinksKLA.vue?vue&type=script&lang=js"
import style0 from "./LinksKLA.vue?vue&type=style&index=0&id=12176c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12176c9a",
  null
  
)

export default component.exports